import styles from "./total-count.module.scss"

const TotalCount = ({total}) => {
    return <span className={styles.class}>Total: {total}</span>
}

export default TotalCount;